//Custom components
import StatCard from '../../../UI/Card/StatCard';

const ActiveProjectsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Submitted Projects' stat={count} />;
};

export default ActiveProjectsWidget;
